import { t } from '@hefe/i18n';
import { BasketballEventType } from '@hefe/models';
import { BasketballEventColor, BasketballEventIcon } from '@hefe/ui';
import styles from './event-icon.component.module.scss';

export interface EventIconComponentProps {
  size?: string | number;
  eventType: BasketballEventType;
}

export default function EventIconComponent(props: EventIconComponentProps) {
  let Icon: any, backgroundColor: string, tooltipText;
  switch (props.eventType) {
    case BasketballEventType.GAME:
      Icon = BasketballEventIcon.GAME;
      backgroundColor = BasketballEventColor.GAME;
      tooltipText = t('game');
      break;
    case BasketballEventType.PRACTICE:
      Icon = BasketballEventIcon.PRACTICE;
      backgroundColor = BasketballEventColor.PRACTICE;
      tooltipText = t('practice');
      break;
    case BasketballEventType.EVENT:
      Icon = BasketballEventIcon.EVENT;
      backgroundColor = BasketballEventColor.EVENT;
      tooltipText = t('events.events.singular');
      break;
    default:
      Icon = BasketballEventIcon.DEFAULT;
      backgroundColor = BasketballEventColor.GAME;
      tooltipText = t('event');
      break;
  }

  return (
    <div
      className={styles['container']}
      style={{ backgroundColor: backgroundColor }}
    >
      <Icon size={18} />
    </div>
  );
}
